module.exports = new __parcel__URL__("cornershop-iphone.ddf7478e.webp").toString();